module.exports = __webpack_public_path__ + "static/media/section-2-img-1.3a34a73a.png";